// client/src/api/ApiRegistrations.js
import flex from './FlexFetch'

function unwrapSuccessData(result) {
  // Uses ?? so result.data === null/undefined falls back to result.
  // Valid server responses for this module never return data: null.
  return result?.data ?? result
}

async function registerPlayer({
  player_id,
  league_id,
  skill_level,
  access_code,
  partner_player_id,
}) {
  const response = await flex.flexFetch(
    '/api/1.0/registrations/registerPlayer',
    {
      method: 'POST',
      body: JSON.stringify({
        player_id,
        league_id,
        skill_level,
        access_code,
        partner_player_id,
      }),
      credentials: 'include',
    },
  )

  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function getEligiblePartners(league_id, player_id, search = '') {
  const params = new URLSearchParams({ league_id, player_id })
  if (search) params.set('search', search)
  const response = await flex.flexFetch(
    `/api/1.0/registrations/getEligiblePartners?${params}`,
    {
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function getPlayersByLeague(league_id) {
  const response = await flex.flexFetch(
    `/api/1.0/registrations/getPlayersByLeague?league_id=${league_id}`,
    {
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function getAssignmentsByLeague(league_id) {
  const response = await flex.flexFetch(
    `/api/1.0/registrations/getAssignmentsByLeague?league_id=${league_id}`,
    {
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function validateAccessCode(access_code) {
  const response = await flex.flexFetch(
    '/api/1.0/registrations/validateAccessCode',
    {
      method: 'POST',
      body: JSON.stringify({ access_code }),
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function removePlayerFromLeague({ player_id, league_id }) {
  const response = await flex.flexFetch(
    '/api/1.0/registrations/removePlayerFromLeague',
    {
      method: 'POST',
      body: JSON.stringify({ player_id, league_id }),
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function getPendingInvites(league_id) {
  const response = await flex.flexFetch(
    `/api/1.0/admin/registrations/pending?league_id=${league_id}`,
    { credentials: 'include' },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function voidPendingInvite({ registration_id }) {
  const response = await flex.flexFetch(
    '/api/1.0/admin/registrations/voidPending',
    {
      method: 'POST',
      body: JSON.stringify({ registration_id }),
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}

async function decouplePartner({ player_id, league_id }) {
  const response = await flex.flexFetch(
    '/api/1.0/admin/registrations/decouplePartner',
    {
      method: 'POST',
      body: JSON.stringify({ player_id, league_id }),
      credentials: 'include',
    },
  )
  const result = await flex.handleResponse(response)
  return unwrapSuccessData(result)
}
const ApiRegistrations = {
  registerPlayer,
  getEligiblePartners,
  getPlayersByLeague,
  getAssignmentsByLeague,
  validateAccessCode,
  removePlayerFromLeague,
  getPendingInvites,
  voidPendingInvite,
  decouplePartner,
}

export default ApiRegistrations
